import { render } from "./PDFPreviewModal.vue?vue&type=template&id=92fc3bf0&scoped=true"
import script from "./PDFPreviewModal.vue?vue&type=script&lang=js"
export * from "./PDFPreviewModal.vue?vue&type=script&lang=js"

import "./PDFPreviewModal.vue?vue&type=style&index=0&id=92fc3bf0&lang=scss&scoped=true"
import "./PDFPreviewModal.vue?vue&type=style&index=1&id=92fc3bf0&lang=scss"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92fc3bf0"]])

export default __exports__